import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Start from '../views/Start.vue'
import ProgrammerBlock from '../views/ProgrammerBlock.vue'
import ProgrammerCamera from '../views/ProgrammerCamera.vue'
import QrReader from '../views/QrReader.vue'
import DisplayQR from '../views/DisplayQR.vue'
import RobotShowBlock from '../views/RobotShowBlock.vue'
import Result from '../views/Result.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Start',
    component: Start,
  },
  {
    path: '/block',
    name: 'Block',
    component: ProgrammerBlock,
  },
  {
    path: '/programmer-camera',
    name: 'ProgrammerCamera',
    component: ProgrammerCamera,
  },
  {
    path: '/qr-reader',
    name: 'QrReader',
    component: QrReader,
  },
  {
    path: '/display-qr',
    name: 'DisplayQR',
    component: DisplayQR,
  },
  {
    path: '/show-block',
    name: 'ShowBlock',
    component: RobotShowBlock,
  },
  {
    path: '/result',
    name: 'Result',
    component: Result,
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

export default router
